import React, { useState, useEffect } from "react";
import "../styles/contact.css";
import { Link } from 'react-router-dom'
import { useForm } from "react-hook-form";
import useWeb3Forms from "@web3forms/react";

const Contact = () => {
  const [agreed, setAgreed] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    formData.append("access_key", "367c3a5b-86c7-445b-b3d1-8000060b9944");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: json,
      });

      const result = await res.json();

      if (result.success) {
        setStatusMessage("Ihre Nachricht wurde erfolgreich gesendet.");
        event.target.reset();
        setAgreed(false);
      } else {
        setStatusMessage("Beim Senden ist ein Fehler aufgetreten.");
      }
    } catch (error) {
      setStatusMessage("Ein technischer Fehler ist aufgetreten.");
    }
  };

  return (
    <section id="kontakt" className="contact-section container py-5">
      <h2 className="display-5 fw-bold mb-4 text-center">
        Lassen Sie uns sprechen
      </h2>
      <p className=" mb-4 text-center">
        Wir freuen uns auf Ihre Nachricht. Beschreiben Sie Ihr Anliegen und wir
        melden uns persönlich bei Ihnen zurück.
      </p>
      <div className="row g-4">
        <div className="col-md-6">
          <h5>Rechtsanwalt Sergej Vorrat</h5>
          <p>
            Kobergerplatz 13<br />
            90408 Nürnberg
            <br />
            Deutschland
          </p>
          <p>
            <strong>Telefon:</strong>{" "}
            <a href="tel:+491577 3430153">01577 3430153</a>
            <br />
            <strong>E-Mail:</strong>{" "}
            <a href="mailto:kanzlei@ravorrat.de">kanzlei@ravorrat.de</a>
          </p>
          <p>
            <strong>Sprechzeiten:</strong>
            <br />
            Termine nach Vereinbarung
          </p>
        </div>

        <div className="col-md-6">
          <form onSubmit={onSubmit}>
            <div className="mb-3">
              <label htmlFor="name" className="form-label">
                Ihr Name
              </label>
              <input
                type="text"
                className="form-control"
                id="name"
                name="name"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Ihre E-Mail-Adresse
              </label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="subject" className="form-label">
                Betreff
              </label>
              <input
                type="text"
                className="form-control"
                id="subject"
                name="subject"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="appointment" className="form-label">
                Wunschtermin
              </label>
              <input
                type="datetime-local"
                className="form-control"
                id="appointment"
                name="appointment"
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="message" className="form-label">
                Nachricht
              </label>
              <textarea
                className="form-control"
                id="message"
                name="message"
                rows="4"
                required
              ></textarea>
            </div>
            <div className="form-check mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="privacy"
                checked={agreed}
                onChange={() => setAgreed(!agreed)}
                required
              />
              <label className="form-check-label" htmlFor="privacy">
  Ich habe die <span><Link to="/privacy">Datenschutzerklärung</Link></span>{" "}
  gelesen und bin mit der Verarbeitung meiner Daten einverstanden.
</label>

            </div>
            <button type="submit" className="btn btn-dark" disabled={!agreed}>
              Nachricht senden
            </button>
            {statusMessage && (
              <p className="form-hint small mt-2 text-muted">{statusMessage}</p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;

